// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2BHd8","buttons":"RemoveExpirationActionButtons_buttons__20eJ6"};